const STORAGE_KEY = 'pdl-decision-review-path-tour-v1';

export function isPdlDecisionReviewPathTourDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dismissed';
  } catch {
    return false;
  }
}

export function markPdlDecisionReviewPathTourDismissed(): void {
  try {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
  } catch {
    // ignore quota / private mode
  }
}
